import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	UntypedFormControl,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { AppDialogComponent } from 'src/app/components/app-dialog/app-dialog.component';
import { StepperDetails } from '../register-user.component';
import {
	MatFormField,
	MatLabel,
	MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { PasswordValidationComponent } from '../../../components/password-validation/password-validation.component';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-create-password',
	templateUrl: './create-password.component.html',
	styleUrls: [
		'./create-password.component.css',
		'../../common/modal.scss',
		'../../common/main.scss',
		'../register-user.component.scss',
	],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		ReactiveFormsModule,
		MatIcon,
		MatSuffix,
		PasswordValidationComponent,
		MatButton,
	],
})
export class CreatePasswordComponent {
	@Output() userPassword = new EventEmitter<string>();
	@Output() updateStepperDetails = new EventEmitter<StepperDetails>();
	@Input() verifiedPhoneNumber = false;

	hide = true;
	passwordFormControl = new UntypedFormControl('');
	confirmPasswordFormControl = new UntypedFormControl('');

	constructor(
		private readonly dialog: MatDialog,
		private readonly stepper: MatStepper
	) {}

	private static validatePassword(
		password: string,
		confirmPassword: string
	): PasswordValidationResult {
		if (password !== confirmPassword) {
			return PasswordValidationResult.notMatching;
		}

		const validPassword =
			password.length >= 6 &&
			password.match(/[A-Z]/) &&
			password.match(/[a-z]/) &&
			password.match(/[0-9]/);
		if (!validPassword) {
			return PasswordValidationResult.invalidPassword;
		}

		return PasswordValidationResult.valid;
	}

	async confirm(): Promise<void> {
		const result = CreatePasswordComponent.validatePassword(
			this.passwordFormControl.value,
			this.confirmPasswordFormControl.value
		);
		switch (result) {
			case PasswordValidationResult.notMatching:
				this.dialog.open(AppDialogComponent, {
					data: {
						title: $localize`:@@createPasswordError:Error`,
						message: $localize`:@@createPasswordPasswordAndConfirmationPasswordDidNotMatch:The password and password confirmation did not match.`,
					},
				});
				break;
			case PasswordValidationResult.invalidPassword:
				this.dialog.open(AppDialogComponent, {
					data: {
						title: $localize`:@@createPasswordInvalidPassword:Invalid password`,
						message: $localize`:@@createPasswordPasswordRequirementsSummary:The new password must be at least 6 characters long, and contain at least 1 uppercase letter, 1 lowercase letter, and 1 numeric value.`,
					},
				});
				break;
			case PasswordValidationResult.valid:
				this.userPassword.emit(this.passwordFormControl.value);
				this.updateStepperDetails.emit({ stepProgress: '75', stepCount: '4' });
				this.stepper.next();
				break;
		}
	}

	onBackClicked(): void {
		if (this.verifiedPhoneNumber) {
			this.updateStepperDetails.emit({ stepProgress: '30', stepCount: '2' });
		} else {
			this.updateStepperDetails.emit({ stepProgress: '10', stepCount: '1' });
		}
		this.stepper.previous();
	}
}

enum PasswordValidationResult {
	valid,
	notMatching,
	invalidPassword,
}
